export default {
  // Settings Page
  PickGameTitle: "Pick Game - Settings",
  candidatesLabel: "Candidate Names Settings",
  candidatesPlaceholder: "Enter candidate names, separated by commas (,), press Enter to add items, maximum 20 candidates, random selection if exceed 10",
  clearSettings: "Clear Settings",
  saveSettings: "Save Settings", 
  candidateExists: "Candidate already exists",
  maxCandidates: "Maximum 20 candidates allowed",
  
  // Game Page
  gameTitle: "Pick Game Wheel",
  spinWheel: "Spin the Wheel",
  winner: "Winner",
  spinAgain: "Spin Again",
  backToSettings: "Back to Settings"
}